<div class="modal-title text-left">{{ getTranslationWithAppName(app ? 'INSTALL' : 'INSTALL_DEFAULT', true) }}</div>
<div class="modal-subtitle with-border">
  <ng-container *ngIf="isStepped">{{ 'APP.INSTALL_STEP' | translate:{step: step, steps: steps} }}</ng-container>
</div>
<div class="modal-content">
  <rosie-alert *ngIf="app?.hasError" [message]="app?.errorMessage || getTranslationWithAppName('INSTALL_FAILED')"
    [type]="'error'" class="my-3">
  </rosie-alert>
  <div *ngIf="!isChoiceStep"
    [innerHtml]="getAppSpecificTranslation(app ? 'INSTALL_DESCRIPTION' : 'INSTALL_DESCRIPTION_DEFAULT', !app)">
  </div>
  <div *ngIf="isChoiceStep" [innerHtml]="getAppSpecificTranslation('INSTALL_CHOICE_DESCRIPTION')"></div>
  <ng-content></ng-content>
  <ng-container
    [ngTemplateOutletContext]="{ form: app?.setupData?.form, formFields: app?.setupData?.formFields, formOptions: formOptions }"
    [ngTemplateOutlet]="form">
  </ng-container>
</div>
<div *ngIf="!app?.hasCredentialsFlow" class="modal-action-line with-border">
  <rosie-button *ngIf="!isChoiceStep" (click)="close()" class="d-block" [customClass]="'secondary narrow'"
    [translationKey]="'COMMON.CANCEL'">
  </rosie-button>
  <rosie-button *ngIf="isChoiceStep" (click)="back.emit()" class="d-block" [customClass]="'secondary narrow'"
    [translationKey]="'COMMON.BACK'">
  </rosie-button>
  <rosie-button *ngIf="isStepped && !isChoiceStep" (click)="next.emit()" class="d-block" [customClass]="'narrow slim'"
    [inProgress]="app?.inProgress" [translationKey]="'APP.NEXT'">
  </rosie-button>
  <rosie-button *ngIf="!isStepped || isChoiceStep" (click)="install.emit()" class="d-block" [customClass]="'narrow slim'"
    [inProgress]="app?.inProgress" [disabled]="hasUnconfirmedRequiredSwitch"
    [translationKey]="app?.hasExternalFlow ? getTranslationWithAppName('CONNECT_WITH_ACTION') : 'APP.CONNECT_ACTION'">
  </rosie-button>
</div>
